
import Vue from 'vue'
import Vuex from 'vuex'
// eslint-disable-next-line no-unused-vars
import { firebaseApp } from '@/components/Firebase_Conn'
import databaseOps from '../js/firebaseOperations.js'
import loginStates from './modules/loginStates'
import curtainStates from './modules/curtainStates'
import crudTableStates from './modules/crudTableStates'
import customerStates from './modules/customerStates'
import ordineStates from './modules/ordineStates'
import sidePanelStates from './modules/sidePanelStates'
import magazzinoStates from './modules/magazzinoStates'
import sideBarStates from './modules/sideBarStates'
import listinoStates from './modules/listinoStates'
import selettoreStates from './modules/selettoreStates'
import fbPointers from './modules/fbPointers'


Vue.use(Vuex)
// eslint-disable-next-line new-cap
var fb = new databaseOps(firebaseApp)
// const debug = process.env.NODE_ENV !== 'production'
export const jStore = new Vuex.Store({
  modules: {
    loginStates,
    curtainStates,
    crudTableStates,
    customerStates,
    ordineStates,
    sidePanelStates,
    magazzinoStates,
    sideBarStates,
    listinoStates,
    selettoreStates,
    fbPointers
  }
})
// inietto l' oggetto che mi permette di utilizzare all interno dello store le operazioni su firebase
Object.assign(jStore, { 'databaseOps': fb })
 console.log(jStore)

// eslint-disable-next-line spaced-comment
/*
if (module.hot) {
  module.hot.accept(crudTableStates, () => {
    jStore.hotUpdate(crudTableStates)
  })
}*/
